import { css } from "@emotion/react";

import { COLORS } from "../../stylesheets/emotion/vars";
import fontBold from "../font/agrandir-narrow-bold.ttf";
import font from "../font/Agrandir-Regular.ttf";
import fontBlack from "../font/Anton-Regular.ttf";
import background from "../images/mary-jane/mary-jane-background-mirror-3.png";

export const maryJaneStyleMultiScreen = css`
    @font-face {
        font-family: "agrandir";
        src: url("${font}");
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: "agrandir-bold";
        src: url("${fontBold}");
        font-weight: bold 1;
        font-style: normal;
    }
    @font-face {
        font-family: "anton-black";
        src: url("${fontBlack}");
        font-weight: bold 2;
        font-style: normal;
    }

    body {
        overflow-y: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
    }

    .bannerAll {
        display: grid;
        grid-template-columns: auto;
    }

    .bannerLogo {
        width: 12vw;
        position: relative;
        margin: 1vw auto 2vw auto;
        z-index: 1000;
    }

    .menukaart {
        width: 100vw;
        height: 177.78vw; /* 16:9 ratio */
        display: grid;
        grid-template-columns: auto auto auto;
        position: relative;
    }

    .menu {
        max-width: 96vw;
        height: 46.5vw;
        margin-left: 1vw;
        margin-right: 1vw;
        margin-top: 2vw;
        position: relative;
    }

    .tableHeader {
        margin-top: 1.5vw;
    }

    .info {
        display: flex;
        flex-direction: row-reverse;
    }

    .row {
        display: flex;
        padding-top: 0.1vw;
        position: relative;
        padding-block: 0.2vw;
    }

    .row::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${COLORS.maryJaneRowColor};
        opacity: 0.72;
        z-index: -1;
    }

    .row:nth-child(even)::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${COLORS.maryJaneRowColor2};
        opacity: 0.72;
        z-index: -1;
    }

    .row:nth-last-child(1) {
        border-bottom-left-radius: 1vw;
        border-bottom-right-radius: 1vw;
    }

    .row:first-child {
        border-top-left-radius: 1vw;
        border-top-right-radius: 1vw;
    }

    .rowContent {
        padding: 0.22vw 0;
        display: flex;
    }

    .productkind {
        color: white;
        font-size: 0.9vw;
        margin-top: 0.3vw;
        width: 3vw;
        margin-left: 2vw;
    }

    .banner {
        width: 100%;
        margin-left: 8vw;
        position: relative;
    }

    @keyframes moveBackground {
        0% {
            background-position: 0 0;
        }
        50% {
            background-position: 100% 60%;
        }
        100% {
            background-position: 0 0;
        }
    }

    .pagebackground {
        width: 100%;
        height: 100vh;
        background-repeat: repeat-y;
        background-image: url("${background}");
        background-size: 150% 150%;
        position: relative;
        overflow: hidden;
        animation: moveBackground 50s linear infinite;
        z-index: -10000;
    }

    .redbg {
        position: absolute;
    }

    .logo {
        position: absolute;
        margin-left: 20%;
        margin-top: -6.5%;
        width: 60%;
        opacity: 0;
        animation: rotation 25s 20s infinite;
    }

    .marginTopTitle {
        margin-top: -2vw;
    }

    .title,
    .titleNotAtTop {
        font-family: "anton-black", "sans-serif";
        margin-left: 1.5vw;
        font-size: 4.5vw;
        margin-top: 1.6vw;
        margin-bottom: 0.2vw;
        position: relative;
        width: 50vw;
        text-transform: uppercase;
        color: ${COLORS.maryJaneColor};
    }

    .particles {
        position: absolute;
        margin-left: 50vw;
        width: 300px;
    }

    .btn {
        position: absolute;
    }

    .kindBadge {
        scale: 1.4;
        margin: auto;
        padding: 0 1.5vw;
    }

    .badgeLetter {
        transform: translateY(0.24vw);
    }

    .nameStar {
        display: flex;
    }

    .newBadge {
        margin-top: 0.1vw;
        scale: 2;
        transform: translateY(-0.3vw) translateX(0.3vw);
    }

    .nameprice {
        font-size: 3vw;
        font-family: "agrandir-bold", "sans-serif";
        text-transform: uppercase;
        margin-top: 0.5vw;
        color: ${COLORS.maryJaneColor};
    }

    .description {
        font-size: 1.4vw;
        font-family: "agrandir", "sans-serif";
        color: ${COLORS.maryJaneDescriptionColor};
        margin: 0 auto;
        display: none;
    }

    .kind {
        font-size: 0.5vw;
        position: relative;
        margin-left: -2vw;
        margin-top: 0.5vw;
        width: 5vw;
        color: ${COLORS.maryJaneColor};
    }

    .priceContainer {
        position: relative;
        right: 0.7vw;
        margin-right: 0.5vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: right;
    }

    .price {
        font-size: 2.8vw;
        font-family: "agrandir", "sans-serif";
        width: 9vw;
        color: ${COLORS.maryJaneDescriptionColor};
        font-weight: bold;
        text-align: right;
    }

    .oldPrice {
        font-size: 2.2vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5.5vw;
        color: grey;
        margin-top: -0.7vw;
        z-index: 1;
        text-decoration: line-through;
    }

    .discountedPrice {
        font-size: 2.8vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5.5vw;
        margin-top: -0.5vw;
        color: red;
        font-weight: bold;
        z-index: 1;
    }

    .priceHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-left: -0.55vw;
        font-size: 2.7vw;
        margin-top: -5vw;
        width: 10vw;
        color: ${COLORS.maryJaneColor};
        line-height: 0.9;
        margin-bottom: 0.8vw;
    }

    .priceHeader .amount {
        font-size: 2.8vw;
        font-weight: 800;
        font-family: "agrandir-bold", "sans-serif";
    }

    .priceHeader .unit {
        font-size: 2.6vw;
        font-family: "agrandir", "sans-serif";
        text-transform: uppercase;
    }

    .filler {
        flex-grow: 1;
    }

    .svg-inline--fa {
        margin-left: 20px;
        margin-top: 8px;
        font-size: 30px;
    }

    .legendNew {
        display: none;
    }

    .categoryImage {
        display: block;
        min-height: 7.7vw;
        max-height: 7.7vw;
        width: auto;
        object-fit: contain;
        margin-top: 2vw;
        margin-bottom: 0.75vw;
        margin-left: 2.6vw;
        filter: brightness(1.15) contrast(0.9) saturate(0.9) drop-shadow(0.15vw 0 ${COLORS.maryJaneBadgeH})
            drop-shadow(-0.15vw 0.15vw ${COLORS.maryJaneBadgeH}) drop-shadow(0 0.15vw ${COLORS.maryJaneBadgeH})
            drop-shadow(0 -0.15vw ${COLORS.maryJaneBadgeH}) /* white outline layer (extra tight) */
            drop-shadow(0.1vw 0 white) drop-shadow(-0.1vw 0.1vw white) drop-shadow(0 0.1vw white)
            drop-shadow(0 -0.1vw white);
    }

    .legend {
        position: absolute;
        bottom: -120vw;
        right: 2vw;
        width: 49vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                padding: 0.75vw;
                .legendBadge {
                    height: 2vw;
                }
                .legendRow {
                    align-items: center;
                    margin-top: 0vw;
                    display: flex;
                    flex-direction: row;
                    padding-right: 2vw;
                    .newIcon {
                        position: relative;
                        margin-right: 0.4vw;
                        scale: 1.3;
                        transform: translateY(-0.5vw) translateX(0.3vw);
                    }
                    .label {
                        padding-left: 0.5vw;
                        font-size: 1.8vw;
                        font-family: "anton-black", "sans-serif";
                        color: ${COLORS.maryJaneColor};
                    }
                }
            }
            .content::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: ${COLORS.maryJaneRowColor};
                opacity: 0.72;
                z-index: -1;
            }
        }
    }
`;
